import type { JSX, ButtonHTMLAttributes } from 'react';
import { pushEvent, useClassNames } from '@CS/hooks';
import { useNavigateQuery } from '@/hooks';
import type { MouseEvent } from 'react';
import CSS from './Button.module.css';

type Child = JSX.Element | string;
type Children<Child> = Child | Child[];
type ClickEvent = MouseEvent<HTMLButtonElement>;

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: (event: ClickEvent) => unknown;
  type?: 'button' | 'submit' | 'reset';
  children?: Children<Child>;
  className?: string;
  gtmConfig?: object;
  disabled?: boolean;

  blank?: boolean;
  width?: string;
  link?: string;
  text?: string;
  id?: string;
};

export const Button = ({
  text = '',
  className,
  gtmConfig,
  disabled,
  children,
  onClick,
  width,
  blank,
  link,
  id,
  ...props
}: ButtonProps) => {
  const navigate = useNavigateQuery();
  const classNames = useClassNames([CSS.standard, className]);

  const onButtonClick = (event: ClickEvent) => {
    gtmConfig && pushEvent(gtmConfig);

    if (!link) onClick?.(event);
    else if (blank) open(link, '_blank');
    else navigate(link);
  };

  return (
    <button
      style={{ width: width || 'auto' }}
      onClick={onButtonClick}
      className={classNames}
      disabled={disabled}
      role="button"
      {...props}
      id={id}
    >
      {text || children}
    </button>
  );
};
